<template>
  <section class="template-style-form">
    <el-form ref="form" label-width="100px">
      <!-- Custom Template Size Section -->
      <el-form-item label="Custom Size">
        <div class="custom-size-section">
          <el-switch
            v-model="styles.enable_custom_size"
            @change="handleCustomSizeToggle"
            active-text="Enable"
            inactive-text="Disable"
          ></el-switch>

          <div v-if="styles.enable_custom_size" class="size-inputs mt-3">
            <div class="flex items-center gap-2 mb-2">
              <label class="text-sm font-medium w-16">Width:</label>
              <el-input-number
                v-model="styles.width"
                @change="updateTemplateSize"
                :min="100"
                :max="2000"
                size="small"
                placeholder="Width"
                style="width: 120px"
              ></el-input-number>
              <span class="text-sm text-gray-500">px</span>
            </div>
            <div class="flex items-center gap-2">
              <label class="text-sm font-medium w-16">Height:</label>
              <el-input-number
                v-model="styles.height"
                @change="updateTemplateSize"
                :min="100"
                :max="2000"
                size="small"
                placeholder="Height"
                style="width: 120px"
              ></el-input-number>
              <span class="text-sm text-gray-500">px</span>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="Background">
        <el-color-picker
          v-model="styles.background"
          @change="saveSettings()"
          show-alpha
        ></el-color-picker>
      </el-form-item>
      <el-form-item label="Border Size" class="TemplateBorderStyle">
        <el-input-number
          v-model="styles.border_size"
          controls-position="right"
          :min="0"
          :max="100"
          size="small"
          style="height: auto !important"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="Border Color">
        <el-color-picker
          v-model="styles.border_color"
          @change="saveSettings()"
          show-alpha
        ></el-color-picker>
      </el-form-item>
      <el-form-item label="Border Type">
        <el-select v-model="styles.border_type" @change="saveSettings()" size="small">
          <el-option
            v-for="(border, index) of borderTypes"
            :value="border.value"
            :label="border.name"
            :key="index"
          >
            <span style="float: left">{{ border.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" v-html="border.demo"></span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-checkbox v-model="styles.icons_required">Show Field Icons</el-checkbox>
      <!-- <el-form-item class="pt-1 save-settings-button">
        <el-button size="medium" type="primary" @click="saveSettings()">Save Settings</el-button>
      </el-form-item> -->
    </el-form>
  </section>
</template>

<script>
  export default {
    name: 'templates-formComponents-TemplateStyleSettings',
    props: ['data'],
    data() {
      return {
        activeName: '1',
        borderSize: 0,
        borderColor: '',
        settings: [
          {
            title: '',
          },
        ],
        borderTypes: [
          {
            name: 'None',
            value: 'none',
            demo: "<span style='border:none;'>abc</span>",
          },
          {
            name: 'Fill',
            value: 'solid',
            demo: "<span style='border:solid;'>abc</span>",
          },
          {
            name: 'Dotted',
            value: 'dotted',
            demo: "<span style='border:dotted;'>abc</span>",
          },
          {
            name: 'Dashed',
            value: 'dashed',
            demo: "<span style='border:dashed;'>abc</span>",
          },
          {
            name: 'double',
            value: 'Double',
            demo: "<span style='border:double;'>abc</span>",
          },
          {
            name: '3D Border groove',
            value: 'groove',
            demo: "<span style='border:groove;'>abc</span>",
          },
          {
            name: '3D Border ridge',
            value: 'ridge',
            demo: "<span style='border:ridge;'>abc</span>",
          },
          {
            name: '3D Border outset',
            value: 'outset',
            demo: "<span style='border:outset;'>abc</span>",
          },
          {
            name: '3D Border inset',
            value: 'inset',
            demo: "<span style='border:inset;'>abc</span>",
          },
        ],
        styles: {},
      };
    },
    watch: {
      data: {
        handler(newData) {
          if (newData) {
            this.styles = { ...newData };
            // Ensure custom size properties are properly set
            if (newData.enabled !== undefined) {
              this.styles.enable_custom_size = newData.enabled;
            }
            if (newData.width !== undefined) {
              this.styles.width = newData.width;
            }
            if (newData.height !== undefined) {
              this.styles.height = newData.height;
            }
          }
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      // Initialize custom size from parent if available
      if (this.data && this.data.enabled !== undefined) {
        this.styles.enable_custom_size = this.data.enabled;
        this.styles.width = this.data.width || 1200;
        this.styles.height = this.data.height || 1000;
      } else {
        // Set default values if not provided
        this.styles.enable_custom_size = false;
        this.styles.width = 1200;
        this.styles.height = 1000;
      }
    },
    methods: {
      saveSettings() {
        // Ensure custom size properties are properly set
        if (this.styles.enable_custom_size) {
          this.styles.width = this.styles.width || 1200;
          this.styles.height = this.styles.height || 1000;
        }

        for (const key in this.styles) {
          if (
            key === 'background' ||
            key === 'border_size' ||
            key === 'border_color' ||
            key === 'border_type' ||
            key === 'width' ||
            key === 'height' ||
            key === 'enable_custom_size'
          ) {
            this.styles[key] === null ? delete this.styles[key] : this.styles[key];
          }
        }

        // Emit updated settings
        this.$emit('settings-updated', this.styles);
      },
      handleCustomSizeToggle() {
        if (this.styles.enable_custom_size) {
          // Enable custom size - validate and emit current values
          this.updateTemplateSize();
        } else {
          // Disable custom size - emit default values or null
          this.$emit('template-size-changed', {
            width: 1200,
            height: 1000,
            enabled: false,
          });
        }
      },
      updateTemplateSize() {
        if (!this.styles.enable_custom_size) return;

        // Validate input values
        if (this.styles.width < 100) this.styles.width = 100;
        if (this.styles.width > 2000) this.styles.width = 2000;
        if (this.styles.height < 100) this.styles.height = 100;
        if (this.styles.height > 2000) this.styles.height = 2000;

        // Emit the updated template size
        this.$emit('template-size-changed', {
          width: this.styles.width,
          height: this.styles.height,
          enabled: this.styles.enable_custom_size,
        });
      },
    },
  };
</script>

<style lang="scss">
  .template-style-form {
    .el-form-item {
      margin-bottom: 15px;

      .el-form-item__content {
        line-height: 25px;
      }
    }

    .el-form-item__label {
      text-align: left !important;
    }

    .custom-size-section {
      .size-inputs {
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        padding: 12px;
        background-color: #fafafa;
      }
    }
  }

  .TemplateBorderStyle .el-input-number--small {
    line-height: 38px !important;
  }
</style>
